import {Component, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {FormControl, FormGroup, FormBuilder, FormArray, Validators} from '@angular/forms';
import {ToastrService} from "ngx-toastr";
import {MatStep} from "@angular/material/stepper";
import {environment} from "../../environments/environment";
import {ConsentService} from "../service/consent.service";

@Component({
  selector: 'app-consentement',
  templateUrl: './consentement.component.html',
  styleUrls: ['./consentement.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class ConsentementComponent implements OnInit {

  onboardingType = '';
  textConfig: any = {};
  inputPerRow = 3;
  rowCount = 0;
  consentForm: FormGroup;
  confirmForm: FormGroup;
  formTemplateArray: any = [];
  state = 'loading';
  group = '';
  idEmitter = '';
  formData: any = [];
  @ViewChild('firstStep', { static: false }) firstStep: MatStep | undefined;
  @ViewChild('secondStep', { static: false }) secondStep: MatStep | undefined;

  constructor(private route: ActivatedRoute, private http: HttpClient, private formBuilder: FormBuilder, private toastr: ToastrService, private router: Router, private consentService: ConsentService) {
    this.consentForm = new FormGroup({});
    this.confirmForm = new FormGroup({
      consent: new FormControl(null, [Validators.requiredTrue]),
    });
  }

  orderAsc(arrayItemA: any, arrayItemB: any) {
    if (parseInt(arrayItemA.order) < parseInt(arrayItemB.order)) {
      return -1;
    }
    if (parseInt(arrayItemA.order) > parseInt(arrayItemB.order)) {
      return 1;
    }
    return 0;
  }

  accept() {
    //Test if checkbox is valid
    if (this.confirmForm.get('consent')?.value != true) {
    } else {
      let data = [];
      for (let i = 0; i < this.information.length; i++) {
        const control = this.information.controls[i];
        data.push({
          key: this.formData[i].name,
          value: control.value.trim(),
        });
      }
      this.http.post(environment.api_url + 'onboarding', {
        payload: data,
        group: this.group,
        idEmitter: this.idEmitter,
        onboardingType: this.onboardingType,
        action: 'consent',
      }, {
        headers: new HttpHeaders({
          'Content-Type':  'application/json',
        })
      }).subscribe(() => {
        this.toastr.success('Consenti avec succès');
        // @ts-ignore
        this.firstStep?.editable = false;
        // @ts-ignore
        this.secondStep?.editable = false;
      }, () => {
        this.toastr.error('Echec du consentement');
        this.router.navigate(['/error']);
      })
    }
  }

  extractOptions(source: string) {
    return source.split('|');
  }

  getLogoUrl(logoName: string) {
    this.http.post(environment.api_url + 'onboarding', {
      group: this.group,
      user: this.idEmitter,
      file_name: logoName,
      action: 'getLogoUrl'
    }, {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
      })
    }).subscribe( (response: any) => {
      const status = (response as any)['status'];
      const logoUrl = (response as any)['logoUrl'];
      this.consentService.getLogoUrlSubject().next(logoUrl);
      },
      error => {
        console.log(error);
      } );
  }

  decodeUrl(data: string) {
    this.http.post(environment.api_url + 'onboarding', {
      data: data,
      action: 'decode',
    }, {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
      })
    }).subscribe((response: any) => {
      const consentControls: FormControl[] = [];
      console.log(response);
      const status = (response as any)['status'];
      if (status === 'KO') {
        this.router.navigate(['/error']);
      }
      this.onboardingType = (response as any)['onboardingType'];
      this.group = (response as any)['group'];
      this.idEmitter = (response as any)['idEmitter'];
      this.textConfig = JSON.parse((response as any)['textConfig']);
      this.consentService.getHeaderTitleSubscription().next(this.textConfig.headerTitle);
      this.getLogoUrl(this.textConfig.logoUrl);
      console.log('Text config');
      console.log(this.textConfig);
      this.formData = JSON.parse((response as any)['config']);
      console.log(this.formData);
      this.formData.sort(this.orderAsc);
      for (let field of this.formData) {
        const formControl = new FormControl('');
        if (field.value != '') {
          formControl.setValue(field.value);
        }
        if (!JSON.parse(field.editable)) {
          formControl.disable();
        }
        if (JSON.parse(field.required)) {
          formControl.addValidators(Validators.required);
        }
        if (field.pattern != '') {
          formControl.addValidators(Validators.pattern(field.pattern));
        }
        consentControls.push(formControl);
      }
      this.consentForm.addControl('information', this.formBuilder.array(consentControls));
      this.rowCount = Math.ceil(this.information.controls.length / this.inputPerRow);
      let indexCounter = 0;
      for (let i = 0; i < this.rowCount; i++) {
        const rowArray: any = [];
        let j = 0;
        while (j < this.inputPerRow && indexCounter < this.information.controls.length) {
          rowArray.push(this.information.controls[indexCounter]);
          j++;
          indexCounter++;
        }
        this.formTemplateArray.push(rowArray);
      }
      this.state = 'loaded';
    },
    () => {
      this.router.navigate(['/error']);
    });
  }

  get information():FormArray{
    return <FormArray> this.consentForm.get('information');
  }

  ngOnInit() {
    this.route.queryParams
      .subscribe(params => {
        const data = params['data'];
        this.decodeUrl(data);
      });
  }

}
